import React from "react";

import Editor from './ASpecialDaysCounterTimerEditor'
import EditorWrapper from '../../EditorWrapper'

import SpecialDaysCounterTimer from "../../common/SpecialDaysCounterTimer";
import EmptyArticle from "../../common/EmptyArticle";

const ASpecialDaysCounter = props => {
    let article = EmptyArticle();
    const { settings } = props;
    article.number = settings.number;
    article.text = settings.text;

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <SpecialDaysCounterTimer
                article={article}
                {...props}
            />
        </div>
    );
};


export default ASpecialDaysCounter;